import { Component, Input, OnInit } from '@angular/core';
import { ColDef, ColumnApi, GridApi, GridReadyEvent } from 'ag-grid-community';
import { AG_GRID_LOCALE_DE } from '../../locale.de';
import { ColliUbersicht } from '../../models/colliubersichtModel';
import { ColliInfoCellComponent } from '../colli-events/colli-info-cell/colli-info-cell.component';

@Component({
  selector: 'lib-colli-ubersicht',
  templateUrl: './colli-ubersicht.component.html',
  styleUrls: ['./colli-ubersicht.component.scss'],
})
export class ColliUbersichtComponent implements OnInit {
  public gridApi: GridApi;
  public gridColumnApi: ColumnApi;
  public columnDef: ColDef[];
  public defaultColDef: ColDef;
  public locale = AG_GRID_LOCALE_DE;

  @Input() colliUbersicht: ColliUbersicht[];

  constructor() {
    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      flex: 1,
      lockPosition: true,
      cellClass: 'locked-col',
    };

    this.columnDef = [
      { field: 'barcode', headerName: 'Barcode', minWidth: 250 },
      // { headerName: 'Hinweise', cellRendererFramework: ColliInfoCellComponent, maxWidth: 120 },
      { field: 'scantypDateKWA', headerName: 'KWA', minWidth: 150 },
      { field: 'scantypDateUBN', headerName: 'UBN', minWidth: 150 },
      { field: 'scantypDateKWE', headerName: 'KWE', minWidth: 150 },
      { field: 'scantypDateRWE', headerName: 'RWE', minWidth: 150 },
      { field: 'scantypDateBLD', headerName: 'BLD', minWidth: 150 },
      { field: 'scantypDateSTW', headerName: 'STW', minWidth: 150 },
      { field: 'scantypDateINV', headerName: 'INV', minWidth: 150 },
      { field: 'scantypDateAUS', headerName: 'AUS', minWidth: 150 },
      { field: 'scantypDateOFL', headerName: 'OFL', minWidth: 150 },
    ];
  }


  ngOnInit(): void {

  }

  gridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.filterData(this.colliUbersicht));
  }


  filterData(data: ColliUbersicht[]): ColliUbersicht[] {
    const resultArray: ColliUbersicht[] = [];
    data.forEach(item => {
      const newItem: ColliUbersicht = {
        barcode: item.barcode,
        // hinweis: item.hinweis,
        scantypDateKWA: this.formatTime(item.scantypDateKWA),
        scantypDateUBN: this.formatTime(item.scantypDateUBN),
        scantypDateKWE: this.formatTime(item.scantypDateKWE),
        scantypDateRWE: this.formatTime(item.scantypDateRWE),
        scantypDateBLD: this.formatTime(item.scantypDateBLD),
        scantypDateSTW: this.formatTime(item.scantypDateSTW),
        scantypDateINV: this.formatTime(item.scantypDateINV),
        scantypDateAUS: this.formatTime(item.scantypDateAUS),
        scantypDateOFL: this.formatTime(item.scantypDateOFL)
      };
      resultArray.push(newItem);
    });
    return resultArray;
  }

  formatTime(dateTime: string): string {
    if (!dateTime) return null;
    const [datePart, timePart] = dateTime.split(' ');
    const [hours, minutes, seconds] = timePart.split(':').map(part => parseInt(part));
    const formattedHours = hours < 10 ? `0${hours}` : hours.toString();
    const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds.toString();
    const formattedMins = minutes < 10 ? `0${minutes}` : minutes.toString();
    return `${datePart} ${formattedHours}:${formattedMins}:${formattedSeconds}`;

  }

  hasData(item: ColliUbersicht): boolean {
    return Object.values(item).some(value => value !== null && value !== undefined && value !== '' && value !== item.barcode && value !== item.hinweis);
  }

}

